module.exports = __webpack_public_path__ + "media/images/lb/770-4edd538cfefc471ba0c0cebad30ab915.svg";